import { createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import useAppUser from 'hooks/useAppUser';
import CommonTable from 'components/table/CommonTable';
import useServerFilteredTable from 'components/table/hooks/useServerFilteredTable';
import { CustomDataField } from 'models/CustomDataField';
import { customDataFieldsQuery } from 'components/domain/customData/fields/customDataFieldsQuery';
import ActionsCell from './cells/ActionsCell';

const CustomFieldsTable = () => {
  const { agencyUid } = useAppUser();
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<CustomDataField>();

  const columns = [
    columnHelper.accessor('name', {
      header: t('pageAutomations.customFields.fieldName'),
      sortDescFirst: true,
    }),
    columnHelper.accessor('type', {
      header: t('pageAutomations.customFields.fieldType'),
    }),
    columnHelper.accessor('variable', {
      header: t('pageAutomations.customFields.variable'),
      enableSorting: false,
    }),
    columnHelper.display({
      id: 'actions',
      header: t('common.actions'),
      cell: ActionsCell,
      meta: {
        showCellTooltip: false,
      },
    }),
  ];

  const { tableInstance, isLoading } = useServerFilteredTable({
    columns,
    getQuery: (options) =>
      customDataFieldsQuery({ ...options, agencyUid: agencyUid! }),
    pageSize: 20,
  });

  return (
    <CommonTable
      data-testid="custom-fields-table"
      emptyState={t('pageAutomations.customFields.emptyTable')}
      isLoading={isLoading}
      tableInstance={tableInstance}
    />
  );
};

export default CustomFieldsTable;
